import styled from "styled-components";

// The caption under a hero metric, shared by both Investments heroes so the same decomposition line
// cannot be styled two ways once its copy is already decided in one place.
export const MetricCaption = styled.span`
  font-size: var(--text-xs);
  font-variant-numeric: tabular-nums;
  color: var(--color-text-secondary);
`;
